import React from "react";
import BlueImage from "../../assets/images/blue.jpeg";
import poweredbyPACI from "../../assets/images/poweredbyPACI.jpeg";
import Logo from "../../assets/images/Branding/LOGO1.png";
import GoogleMapsIcon from "../../assets/images/google-maps.png";
import EnquiryResultImage from "../../assets/images/Home Page/260X260.jpg";
import EnquiryResualtMap from "./EnquiryResualtMap";
import { WhatsappShareButton, WhatsappIcon } from 'react-share';

function EnquiryResult({ result }) {
  // console.log(result.status, "result.status");
  const sharedContent = `
  نظام الاستعلام الآلي للدكتور محمد هادي الحويلة:
  الدائرة: ${result && result.aldaayira}
  المدرسة: ${result && result.school}
  اللجنة: ${result && result.committee}
  رقم القيد: ${result && result.number_of_registration}
  المنطقة: ${result && result.area}
  حالة القيد: ${result && result.status ? result.status : 'مقيد'}
  الاسم: ${result && result.name}
  موقع لجنة التصويت: https://www.google.com/maps/search/${result.Y},${result.X}
  
`.trim();
  return (
    <React.Fragment>
      <div className="Enquiry__Result m-0 p-0">
        {
          <div className="Enquiry__Result__Body row">
            <div className="Enquiry__Result__Body__Item col-lg-6 col-md-12 col-sm-12 col-xs-12">
              <div className="d-flex justify-content-between flex-wrap ">
                <div className="">
                  <span>
                    <i className="fas fa-map-marker-alt px-2"></i>
                    الدائرة:
                  </span>
                  <span className="px-4 py-1 mx-2 bg-light rounded-pill text-dark ">
                    {result && result.aldaayira ? (
                      result.aldaayira
                    ) : (
                      <span className="text-danger">لا يوجد</span>
                    )}
                  </span>
                </div>
              </div>

              <div className="d-flex justify-content-between flex-wrap ">
                <div className="">
                  <span>
                    <i className="fas fa-school px-2"></i>
                    المدرسة :
                  </span>
                  <span className="px-4 py-1 mx-2 bg-light rounded-pill text-dark ">
                    {result && result.school ? (
                      result.school
                    ) : (
                      <span className="text-danger">لا يوجد</span>
                    )}
                  </span>
                </div>
              </div>

              <div className="d-flex justify-content-between flex-wrap ">
                <div>
                  <span>
                    <i className="fas fa-user px-2 "></i>
                    اللجنة :
                  </span>
                  <span className="px-4 py-1 mx-2 bg-light rounded-pill text-dark ">
                    {result && result.committee ? (
                      result.committee
                    ) : (
                      <span className="text-danger">لا يوجد</span>
                    )}
                  </span>
                </div>

                <div>
                  <span>
                    <i className="fas fa-id-card px-2"></i>
                    رقم القيد :
                  </span>
                  <span className="px-4 py-1 mx-2 bg-light rounded-pill text-dark ">
                    {result && result.number_of_registration ? (
                      result.number_of_registration
                    ) : (
                      <span className="text-danger">لا يوجد</span>
                    )}
                  </span>
                </div>
              </div>

              <div className="d-flex justify-content-between flex-wrap ">
                <div className="">
                  <span>
                    <i className="fas fa-map-marker-alt px-2"></i>
                    المنطقة :
                  </span>
                  <span className="px-4 py-1 mx-2 bg-light rounded-pill text-dark ">
                    {result && result.area ? (
                      result.area
                    ) : (
                      <span className="text-danger">لا يوجد</span>
                    )}
                  </span>
                </div>
                <div className="">
                  <span>
                    <i className="fas fa-map-marker-alt px-2"></i>
                    حالة القيد :
                  </span>
                  <span className="px-4 py-1 mx-2 bg-light rounded-pill text-dark ">
                    {result && result.status === undefined ? (
                      <span className="text-danger">غير موجود</span>
                    ) : (
                      (() => {
                        switch (result.status) {
                          case null:
                            return <span className="">مقيد </span>;
                          default:
                            return (
                              <span className="px-4 py-1 mx-2 bg-light rounded-pill text-dark ">
                                {result.status}
                              </span>
                            );
                        }
                      })()
                    )}
                  </span>
                </div>
              </div>

              <div className="d-flex justify-content-start flex-wrap ">
                <div className="">
                  <span>
                    <i className="fas fa-map-marker-alt px-2"></i>
                    الاسم :
                  </span>
                  <span className="px-4 py-1 mx-2 bg-light rounded-pill text-dark ">
                    {result && result.name ? (
                      result.name
                    ) : (
                      <span className="text-danger">لا يوجد</span>
                    )}
                  </span>
                </div>
              </div>
              <div className="d-flex justify-content-start flex-wrap ">
              <WhatsappShareButton url={sharedContent}>
        <WhatsappIcon size={32} round />
        </WhatsappShareButton>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center align-items-center">
              <img
                src={EnquiryResultImage}
                alt="candidate"
                className="img-fluid rounded-circle"
                style={{ width: "260px", height: "260px" }}
              />
            </div>
          </div>
        }
        {
          <EnquiryResualtMap
            voter={result ? result : null}
            photo={EnquiryResultImage}
          />
        }
      </div>
    </React.Fragment>
  );
}

export default EnquiryResult;
